import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { BookOpen, PenTool, Lightbulb, HeartHandshake } from 'lucide-react';
const features = [{
  icon: BookOpen,
  text: 'Manual completo en formato digital (PDF alta calidad)'
}, {
  icon: PenTool,
  text: 'Ejercicios prácticos para hacer individualmente y en pareja'
}, {
  icon: Lightbulb,
  text: 'Guiones de conversación para abordar temas difíciles sin pelear'
}, {
  icon: HeartHandshake,
  text: 'Herramientas de reparación rápida post-conflicto'
}];
export function OfferSection() {
  return <Section background="primary" className="overflow-hidden" id="oferta" data-id="element-145">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="order-2 lg:order-1" data-id="element-147">
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-6 leading-tight" data-id="element-148">
            Todo lo que necesitás para transformar tu relación
          </h2>
          <p className="text-muted mb-8 text-lg" data-id="element-149">
            Un manual diseñado para leerse fácil, pero con la profundidad
            necesaria para generar cambios reales y duraderos.
          </p>

          <ul className="space-y-4 mb-10" data-id="element-150">
            {features.map((feature, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-navy-800 rounded-xl p-4 border border-navy-border" data-id="element-151">
                <div className="mt-0.5 min-w-[24px] text-accent" data-id="element-152">
                  <feature.icon size={20} data-id="element-153" />
                </div>
                <span className="text-gray-200" data-id="element-154">{feature.text}</span>
              </motion.li>)}
          </ul>

          <div className="flex flex-col sm:flex-row items-center gap-6 mb-8" data-id="element-155">
            <div className="text-center sm:text-left" data-id="element-156">
              <span className="block text-sm text-muted uppercase tracking-wider mb-1" data-id="element-157">
                Inversión en tu relación
              </span>
              <span className="text-4xl font-bold text-white" data-id="element-158">
                $9.900{' '}
                <span className="text-lg text-muted font-normal" data-id="element-159">ARS</span>
              </span>
            </div>
          </div>

          <Button size="lg" className="w-full sm:w-auto" icon href="https://www.mujerdigital2.com/cart/PLACEHOLDER:1" data-id="element-160">
            QUIERO EL MANUAL AHORA
          </Button>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="order-1 lg:order-2" data-id="element-161">
          <img src="https://cdn.magicpatterns.com/uploads/gjfFxXFG4YqvMZTWJDEjDe/Mockup.png" alt="Vínculos de Hierro - Mockup del manual en tablet" className="w-full max-w-md mx-auto drop-shadow-2xl" data-id="element-162" />
        </motion.div>
      </div>
    </Section>;
}